import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import moment from 'moment'
import { Table } from 'advenio-components'
import RatingsActions from '../../Data/Redux/RatingsRedux'
import LoadingSpinner from '../../Components/LoadingSpinner'
import { ReportHeader, Container, LoadingContainer, TableContainer, TableHeader, CellContainer } from '../../Components/ReportsComponents'
import CentersInfoActions from '../../Data/Redux/CentersInfoRedux'

class PoorRatings extends Component {
  constructor(props) {
    super(props)
    this.state = {
      width: 0,
    }
  }

  componentWillMount() {
    const { match, activeCenter, getCentersInfo, setCenter, getRatings } = this.props
    if (this.props.fromCenter) {
      if (match.params) {
        setCenter(match.params.centerId)
        getCentersInfo(match.params.centerId, 'ratings')
      } else if (activeCenter !== 0) {
        getCentersInfo(activeCenter, 'ratings')
      }
    } else {
      getRatings()
    }
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }


  render() {
    const { width } = this.state
    const { ratings, centersInfo, fromCenter } = this.props
    return (
      <Container>
        <ReportHeader>
          Ratings Bajos
          {(ratings || centersInfo) &&
          <span style={{ opacity: '.5' }}>{`${moment(!fromCenter ? ratings[0].created_at : centersInfo[0].created_at).format('DD/MM/YY')} - ${moment(!fromCenter ? ratings[ratings.length - 1].created_at : centersInfo[centersInfo.length - 1].created_at).format('DD/MM/YY')}`}</span>
          }
        </ReportHeader>
        {(ratings || centersInfo) ?
          <TableContainer>
            <Table
              data={(ratings || centersInfo)}
              columns={[
                {
                  id: '1',
                  Header: () => <TableHeader>Rating</TableHeader>,
                  accessor: ({ rating }) => ({ rating }),
                  Cell: ({ value: { rating } }) => <CellContainer center><span>{rating}</span></CellContainer>,
                  maxWidth: 80,
                },
                {
                  id: '2',
                  Header: () => <TableHeader>Tutor</TableHeader>,
                  accessor: ({ parent }) => ({ parent }),
                  Cell: ({ value: { parent } }) => <CellContainer><span>{parent.full_name}</span></CellContainer>,
                  maxWidth: 160,
                },
                {
                  id: '3',
                  Header: () => <TableHeader>Comentario</TableHeader>,
                  accessor: ({ comments }) => ({ comments }),
                  Cell: ({ value: { comments } }) => <CellContainer><span>{comments}</span></CellContainer>,
                },
                {
                  id: '4',
                  Header: () => <TableHeader>Fecha</TableHeader>,
                  accessor: ({ created_at }) => ({ created_at }),
                  Cell: ({ value: { created_at } }) => <CellContainer center><span>{moment(created_at).format('DD/MM/YY')}</span></CellContainer>,
                  maxWidth: 85,
                }
              ]}
              />
          </TableContainer>
          :
          <LoadingContainer>
            <LoadingSpinner />
          </LoadingContainer> }
      </Container>
    )
  }
}


const mapStateToProps = ({ ratings, centersInfo }) => ({
  ratings: ratings.get.results.poor_ratings,
  centersInfo: centersInfo.ratings.results.poor_ratings,
  activeCenter: centersInfo.center,
})

const mapDispatchToProps = dispatch => ({
  getRatings: () => dispatch(RatingsActions.getRequest({}, true)),
  getCentersInfo: (id, path) => dispatch(CentersInfoActions.getCentersInfoRequest(id, path)),
  setCenter: id => dispatch(CentersInfoActions.setCenter(id)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PoorRatings))



// WEBPACK FOOTER //
// ./src/Containers/Reports/PoorRatings.jsx